module.exports = {"140481001":"潞华街道","140481002":"成家川街道","140481100":"店上镇","140481101":"微子镇","140481102":"辛安泉镇","140481103":"翟店镇","140481200":"合室乡","140481201":"黄牛蹄乡","140481202":"史回乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140481.json
// module id = 394
// module chunks = 0